import {
    LOGIN_REQUESTED,
    LOGIN_SUCCEEDED,
    LOGIN_FAILED,
    PAYMENT_REQUESTED,
    PAYMENT_SUCCEEDED,
    PAYMENT_FAILED,
    CLEAR_ERROR_MESSAGES,
    UPDATE_USER_REQUESTED,
    SIGNUP_REQUESTED,
    SIGNUP_SUCCEEDED,
    SIGNUP_FAILED,
    ROLE_SWITCH_REQUESTED,
    ROLE_SWITCH_SUCCEEDED,
    ROLE_SWITCH_FAILED,
    FB_LOGIN_REQUESTED,
    PARTNER_SIGNUP_REQUESTED,
    PARTNER_SIGNUP_SUCCESSFUL,
    PARTNER_SIGNUP_FAILED,
    CLEAR_FORGOT_FLAGS,
    FORGOT_PASSWORD_REQUESTED,
    FORGOT_PASSWORD_SUCCEEDED,
    FORGOT_PASSWORD_FAILED,
    VERIFICATION_CODE_SET,
    RESET_PASSWORD_REQUESTED,
    RESET_PASSWORD_SUCCEEDED,
    RESET_PASSWORD_FAILED,
    UPDATE_PARTNER_LICENSE,
    GET_PACKAGE_PRICING_REQUEST,
    GET_PACKAGE_PRICING_SUCCESSFUL,
    GET_PACKAGE_PRICING_FAILED,
    GET_PARTNER_LIST_REQUEST,
    GET_PARTNER_LIST_SUCCESSFUL,
    GET_PARTNER_LIST_FAILED,
    GET_PARTNER_TOKEN_REQUEST,
    GET_PARTNER_TOKEN_SUCCESSFUL,
    GET_PARTNER_TOKEN_FAILED,
    GET_REFRESH_TOKEN_REQUEST,
    GET_REFRESH_TOKEN_SUCCESSFUL,
    GET_REFRESH_TOKEN_FAILED,
    SET_SELECTED_PARTNER,
    RESET_VIEW_AS,
    PERMISSIONS_REQUESTED,
    PERMISSIONS_SUCCEEDED,
    PERMISSIONS_FAILED,
} from './constants';

const initialState = {
    // indicates whether the current user is logged in or not
    isLoggedIn: false,

    // indicated that the login is in progress
    loginInProgress: false,

    // indicated that the logout is in progress
    logoutInProgress: false,

    // indicated that the payment is in progress
    paymentInProgress: false,

    // user's credentials when login is requested
    userCreds: {},

    // user to be stored after successful login
    user: {
        token: null,
        rolePermissions: {
            permissions: {},
        },
    },

    // Fetching permission for the user roles on each page change
    fetchingPermissions: false,

    // Package that is shown on payment's page - e.g. 'Inspire'
    activePackage: null,

    // Price of the package that is shown on payment's page - e.g. name: 'Inspire' price: $99, expects the number to be formatted
    activePackagePrice: null,

    // key of the active package, required at the back-end for transition of roles/permission
    activePackageKey: null,

    // Storing payment success
    payment: {},

    // Storing card payment credentials
    tokenCreds: {},

    // error message
    loginError: null,

    // logout error message
    logoutError: null,

    // Payment error message
    paymentError: null,

    // Forgot password states
    forgetPasswordLoading: false,
    forgotPasswordEmail: null,
    forgotPasswordSuccessfull: false,
    forgotPasswordError: null,

    // one time password states
    verificationCode: null,
    verificationCodeSet: false,

    // resetting password
    resettingPassword: false,
    resetEmail: null,
    resetPasswordSuccessfull: false,
    resetPasswordError: null,

    isVerifyingEmail: false,
    verificationInProcess: false,
    pwdResetCompleted: false,
    pwdResetInProcess: false,

    signUpInProgress: false,
    signUpError: null,
    subscription: false,

    //partner details
    partnerDetails: null,
    partnerSignupError: null,

    isPartnerSignedup: false,

    hasCompletedProfile: false,

    partnerLicense: {},
    pricing: [],
    loadingPrice: false,
    partnerList: [],
    hasMorePartners: true,
    selectedPartner: null,
    viewAsPartner: false,
    limit: 1000,
    skip: 0,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PERMISSIONS_REQUESTED: {
            return {
                ...state,
                fetchingPermissions: true,
            };
        }
        case PERMISSIONS_SUCCEEDED:
        case PERMISSIONS_FAILED: {
            return {
                ...state,
                fetchingPermissions: false,
            };
        }
        case LOGIN_REQUESTED: {
            const {
                userCreds,
                activePackage,
                activePackagePrice,
                activePackageKey,
            } = action;
            return {
                ...state,
                loginInProgress: true,
                loginError: null,
                activePackage,
                activePackagePrice,
                activePackageKey,
                userCreds,
            };
        }
        case FB_LOGIN_REQUESTED: {
            const {
                userCreds,
                activePackage,
                activePackagePrice,
                activePackageKey,
                activePackageId,
            } = action;
            return {
                ...state,
                loginInProgress: true,
                loginError: null,
                activePackage,
                activePackagePrice,
                activePackageKey,
                activePackageId,
                userCreds,
            };
        }
        case LOGIN_SUCCEEDED: {
            const { user } = action;
            const { token } = user;
            return {
                ...state,
                loginInProgress: false,
                isLoggedIn: true,
                loginError: null,
                userCreds: null,
                user,
                token,
            };
        }
        case UPDATE_USER_REQUESTED: {
            const { user } = action;
            return {
                ...state,
                user,
            };
        }
        case LOGIN_FAILED: {
            const { loginError } = action;
            return {
                ...state,
                loginInProgress: false,
                loginError,
            };
        }
        case SIGNUP_REQUESTED: {
            const {
                userCreds,
                activePackage,
                activePackagePrice,
                activePackageKey,
                subscription,
                activePackageId,
            } = action;
            return {
                ...state,
                signUpInProgress: true,
                signUpError: null,
                activePackage,
                activePackagePrice,
                activePackageKey,
                userCreds,
                subscription,
                activePackageId,
            };
        }
        case SIGNUP_SUCCEEDED: {
            const { user } = action;
            const { token } = user;
            return {
                ...state,
                signUpInProgress: false,
                isLoggedIn: true,
                signUpError: null,
                userCreds: null,
                user,
                token,
            };
        }
        case SIGNUP_FAILED: {
            const { signUpError } = action;
            return {
                ...state,
                signUpInProgress: false,
                signUpError,
            };
        }
        case PAYMENT_REQUESTED: {
            const {
                tokenCreds,
                activePackage,
                activePackagePrice,
                activePackageKey,
                activePackageId,
            } = action;
            return {
                ...state,
                paymentInProgress: true,
                paymentError: null,
                activePackage,
                activePackagePrice,
                activePackageKey,
                activePackageId,
                tokenCreds,
            };
        }
        case PAYMENT_SUCCEEDED: {
            const { payment } = action;
            return {
                ...state,
                paymentInProgress: false,
                paymentError: null,
                payment,
            };
        }
        case PAYMENT_FAILED: {
            const { paymentError } = action;
            return {
                ...state,
                paymentInProgress: false,
                paymentError,
            };
        }
        case CLEAR_ERROR_MESSAGES: {
            return {
                ...state,
                loginError: null,
                signUpError: null,
                forgotPasswordError: null,
                verificationError: null,
                resetPasswordError: null,
            };
        }
        case ROLE_SWITCH_REQUESTED: {
            const { requestedRole } = action;
            return {
                ...state,
                requestedRole,
            };
        }
        case ROLE_SWITCH_SUCCEEDED: {
            const { switchedRole } = action;
            const {
                token,
                rolePermissions,
                isPartner,
                partner,
                roles,
            } = switchedRole;
            const { user } = state;
            return {
                ...state,
                token,
                user: {
                    ...user,
                    rolePermissions,
                    partner,
                    isPartner,
                    roles,
                },
            };
        }
        case ROLE_SWITCH_FAILED: {
            const { roleSwitchError } = action;
            return {
                ...state,
                roleSwitchError,
            };
        }
        case PARTNER_SIGNUP_REQUESTED: {
            const { partnerDetails } = action;
            // console.log('IN REDUCER');
            return {
                ...state,
                partnerDetails,
                hasCompletedProfile: false,
            };
        }
        case PARTNER_SIGNUP_SUCCESSFUL: {
            const { rolePermissions, roles } = action;
            const { user } = state;
            if (rolePermissions) {
                user.rolePermissions = rolePermissions;
            }
            if (roles) {
                user.roles = roles;
            }
            return {
                ...state,
                user,
                isPartnerSignedup: true,
                hasCompletedProfile: true,
            };
        }
        case PARTNER_SIGNUP_FAILED: {
            const { error } = action;
            return {
                ...state,
                partnerSignUpError: error,
                isPartnerSignedup: false,
                hasCompletedProfile: false,
            };
        }
        case CLEAR_FORGOT_FLAGS: {
            return {
                ...state,
                forgotPasswordSuccessfull: false,
                verificationCodeSet: false,
                resetPasswordSuccessfull: false,
            };
        }
        case FORGOT_PASSWORD_REQUESTED: {
            const { email } = action;
            return {
                ...state,
                forgotPasswordEmail: email,
                forgetPasswordLoading: true,
            };
        }
        case FORGOT_PASSWORD_SUCCEEDED: {
            const { message } = action;
            return {
                ...state,
                forgotPasswordSuccessfull: message,
                forgetPasswordLoading: false,
            };
        }
        case FORGOT_PASSWORD_FAILED: {
            const { error } = action;
            return {
                ...state,
                forgotPasswordSuccessfull: false,
                forgotPasswordError: error,
                forgetPasswordLoading: false,
            };
        }

        case VERIFICATION_CODE_SET: {
            const { code } = action;
            return {
                ...state,
                verificationCode: code,
                verificationCodeSet: true,
            };
        }

        case RESET_PASSWORD_REQUESTED: {
            return {
                ...state,
                resettingPassword: true,
                resetPasswordSuccessfull: false,
            };
        }
        case RESET_PASSWORD_SUCCEEDED: {
            return {
                ...state,
                resetPasswordSuccessfull: true,
                resettingPassword: false,
            };
        }
        case RESET_PASSWORD_FAILED: {
            return {
                ...state,
                resetPasswordSuccessfull: false,
                resetPasswordError: action.error,
                resettingPassword: false,
            };
        }
        case UPDATE_PARTNER_LICENSE: {
            const { partnerLicense } = action;
            return {
                ...state,
                partnerLicense,
            };
        }
        case GET_PACKAGE_PRICING_REQUEST: {
            return {
                ...state,
                loadingPrice: true,
            };
        }
        case GET_PACKAGE_PRICING_FAILED: {
            return {
                ...state,
                loadingPrice: false,
                priceError: action.error,
            };
        }
        case GET_PACKAGE_PRICING_SUCCESSFUL: {
            return {
                ...state,
                loadingPrice: false,
                pricing: action.pricing,
            };
        }
        case GET_PARTNER_LIST_REQUEST: {
            return {
                ...state,
                loadingPartnerList: true,
            };
        }
        case GET_PARTNER_LIST_FAILED: {
            return {
                ...state,
                loadingPartnerList: false,
                partnerListError: action.error,
            };
        }
        case GET_PARTNER_LIST_SUCCESSFUL: {
            return {
                ...state,
                loadingPartnerList: false,
                partnerList: [...state.partnerList, ...action.partners],
                skip: state.skip + state.limit,
                hasMorePartners: !!action.partners.length,
            };
        }
        case GET_PARTNER_TOKEN_REQUEST: {
            return {
                ...state,
                refreshingToken: true,
            };
        }
        case GET_PARTNER_TOKEN_FAILED: {
            return {
                ...state,
                refreshingToken: false,
                tokenError: action.error,
            };
        }
        case GET_PARTNER_TOKEN_SUCCESSFUL: {
            const {
                token,
                rolePermissions,
                partner,
                isPartner,
            } = action.partner;
            return {
                ...state,
                refreshingToken: false,
                viewAsPartner: true,
                user: {
                    ...state.user,
                    rolePermissions,
                    token,
                    partner,
                    isPartner,
                    partnerId: partner.id,
                },
                token,
            };
        }
        case GET_REFRESH_TOKEN_REQUEST: {
            return {
                ...state,
                refreshingToken: true,
            };
        }
        case GET_REFRESH_TOKEN_FAILED: {
            return {
                ...state,
                refreshingToken: false,
                tokenError: action.error,
            };
        }
        case GET_REFRESH_TOKEN_SUCCESSFUL: {
            const {
                token,
                rolePermissions,
                partnerId,
                isPartner,
                partner,
            } = action.user;

            return {
                ...state,
                refreshingToken: false,
                viewAsPartner: false,
                user: {
                    ...state.user,
                    partnerId,
                    rolePermissions,
                    token,
                    partner,
                    isPartner,
                },
                token,
                selectedPartner: null,
            };
        }
        case SET_SELECTED_PARTNER: {
            return {
                ...state,
                selectedPartner: action.value,
            };
        }
        case RESET_VIEW_AS: {
            return {
                ...state,
                partnerList: [],
                refreshingToken: false,
                hasMorePartners: true,
                selectedPartner: state.viewAsPartner
                    ? state.selectedPartner
                    : null,
                skip: 0,
            };
        }
        default:
            return state;
    }
}
